import script from "./Business.vue?vue&type=script&lang=ts&setup=true"
export * from "./Business.vue?vue&type=script&lang=ts&setup=true"

import "./Business.vue?vue&type=style&index=0&id=dd443808&scoped=true&lang=less"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd443808"]])

export default __exports__